import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { AlertController, ModalController, Platform } from '@ionic/angular';
import { auditTime, distinctUntilChanged, Subscription } from 'rxjs';
import { DataStorageService } from 'src/app/services/data-storage/data-storage.service';
import * as _ from "lodash";
import { Store } from '@ngrx/store';
import * as fromApp from "../../../store/app.reducer";
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-reservation-edit-comment-modal',
  templateUrl: './reservation-edit-comment-modal.component.html',
  styleUrls: ['./reservation-edit-comment-modal.component.scss'],
})
export class ReservationEditCommentModalComponent implements OnInit, OnDestroy {
  @Input() store_id;
  @Input() res_id;
  @Input() original_comment;

  private unsubscribeBackEvent;
  private authSubscription: Subscription;
  private mo_token;

  public loading = false;
  public comment;

  // public input_max_length = 255;

  constructor(private modalController: ModalController,
              private platform: Platform,
              private dataStorageService: DataStorageService,
              private store: Store<fromApp.AppState>,
              private alertController: AlertController,
              private translateService: TranslateService
  ) { }

  ngOnInit() {
    this.unsubscribeBackEvent = this.platform.backButton.subscribeWithPriority(
      300,
      () => {
        if (this.platform.is("android")) {
          this.closeModal();
        }
      }
    );

    this.authSubscription = this.store
      .select("auth")
      .pipe(auditTime(200))
      .pipe(distinctUntilChanged())
      .subscribe(async (state) => {
        if (state && !_.isEqual(this.mo_token, state.mo_token)) {
          this.mo_token = _.cloneDeep(state.mo_token);
        }
      });

    this.comment = this.original_comment;
    if (!this.comment) {
      this.comment = "";
    }
  }

  update_comment() {
    if (this.loading) {
      return;
    }

    const reservation = {
      store_id: this.store_id,
      res_id: this.res_id,
      customer_notes: this.comment || ""
    };

    this.loading = true;
    this.dataStorageService.handleReservation(
      this.mo_token,
      reservation,
      "edit_comment"
    ).subscribe({
      next: async (res: any) => {
        if (!res || !res.success) {
          const alert = await this.alertController.create({
            header: this.translateService.instant("alert"),
            message:
              res && res.comment_id
                ? this.translateService.instant(res.comment_id)
                : this.translateService.instant(
                    "errorMessages.general_error"
                  ),
            backdropDismiss: false,
            buttons: ["OK"],
          });
          await alert.present();
          this.loading = false;
        } else {
          this.loading = false;
          this.modalController.dismiss();
        }
      },
      error: async (error) => {
        const alert = await this.alertController.create({
          header: this.translateService.instant("alert"),
          message: this.translateService.instant(
            "errorMessages.problem_reaching_server"
          ),

          buttons: ["OK"],
        });
        await alert.present();
        this.loading = false;
      },
    });
  }

  closeModal() {
    this.modalController.dismiss();
  }

  ngOnDestroy() {
    if (this.unsubscribeBackEvent) {
      this.unsubscribeBackEvent.unsubscribe();
    }
    if (this.authSubscription) {
      this.authSubscription.unsubscribe();
    }
  }
}
